<template>
  <div class="login-box">
    <template v-if="Object.keys(user).length == 0">
      <div class="login-text">您好，请在此<span class="btn" @click="login">【登录】</span></div>
    </template>
    <template v-else>
      <div class="logout-text">
        欢迎您，{{ user.username }}
        <template v-if="isSelectedRole">，【{{ selectedRole.server_name }}】{{ selectedRole.role_name }}</template>！
        <!-- <span class="btn" @click="bindRole">{{ isSelectedRole ? '【更改绑定】' : '【绑定角色】' }}</span> -->
        <span class="btn" @click="logout">【退出】</span>
      </div>
    </template>
  </div>
</template>

<script>
import loginBoxMixins from '@/mixins/loginBoxMixins.js'

export default {
  name: 'MobileHomeLoginBox',
  mixins: [loginBoxMixins],
  computed: {
    user() {
      return this.$store.getters.user
    },
    selectedRole() {
      return this.$store.getters.selectedRole
    },
    isSelectedRole() {
      return Object.keys(this.selectedRole).length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.login-box {
  position: fixed;
  z-index: 2;
  top: 15vw;
  left: 3.2vw;
  padding: 0 2.666666vw;
  min-width: 44vw;
  height: 4vw;
  font-size: 2.666666vw;
  color: #fff;
  background: rgba($color: #0b0b0b, $alpha: .7);
  border-radius: 2.666666vw;
}

.login-text,
.logout-text {
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 4vw;

  .btn {
    cursor: pointer;
  }

  span {
    color: #388176;
  }
}
</style>